export class Credential {
  constructor(
    public email: string,
    public password: string
  ) {  }
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/core/credential.ts